import router from './router'
import store from './store/index'
import {Loading, Message} from 'element-ui'
import {Decrypt} from '@/utils/caypto'
import {getUserId, removeUserId} from '@/utils/cookie'
// import {getUserId, setUserId, removeUserId} from '@/utils/cookie'
const whiteList = ['/index','/login','/register','/forgotPassword','/ngsure','/augury'] // 不重定向白名单
//判断登录是否超时
router.beforeEach((to, from, next) => {
  if(to.path=="/register" && localStorage.getItem("switch")==1){
    console.log(localStorage.getItem("languageSet"))
    if(localStorage.getItem("languageSet")==null || localStorage.getItem("languageSet")=='zh'){
      Message({
        message: "注册功能已被禁用",
        type: 'error',
        duration: 5 * 1000
      })
    }else if(localStorage.getItem("languageSet")=='en'){
      Message({
        message: "The registration function has been disabled",
        type: 'error',
        duration: 5 * 1000
      })
    }
    return false;
  }
  if (getUserId()) {
    if (to.path === '/login') {
      next(`/index?redirect=${to.path}`)
    } else {
      next();
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      var login_time = localStorage.getItem("web_login_time");
      if (login_time) {
        login_time = Decrypt(login_time);
        var myDate = new Date();
        var year = myDate.getFullYear();    //获取完整的年份(4位,1970-????)
        var month = myDate.getMonth() + 1;       //获取当前月份(0-11,0代表1月)
        var date = myDate.getDate() + 1;        //获取当前日(1-31)
        if (month < 10) {
          month = '0' + month;
        }
        if (date < 10) {
          date = '0' + date;
        }
        var time = year + "-" + month + "-" + date
        var startDate = Date.parse(login_time);
        var endDate = Date.parse(time);
        var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
        if (days <= 5) {
          var user = Decrypt(localStorage.getItem("web_login_user"));
          var password = Decrypt(localStorage.getItem("web_login_password"));
          this.loading = Loading.service({
            lock: true,
            text: '登录中……',
            spinner: 'el-icon-loading',//自定义加载图标类名
            background: 'rgba(0, 0, 0, 0.7)'
          });
          store.dispatch('Login', {username: user, password: password}).then((response) => {
            this.loading = false
            if(localStorage.getItem("click_route")){
              if(localStorage.getItem("click_route")=='/ngsure'){
                localStorage.setItem('create_click_bg','n');
              }else{
                localStorage.setItem('create_click_bg','a');
              }
              this.$router.push({path: localStorage.getItem("click_route")})
            }else{
              this.$router.push({path: '/index'})
            }
          }).catch(() => {
            this.loading = false
          })
        }
      }else{
        if(localStorage.getItem("web_user")){
          Message({
            message: "登录超时",
            type: 'error',
            duration: 5 * 1000
          })
          localStorage.removeItem("web_user")
          next(`/login?redirect=${to.path}`)
        }else{
          next();
        }
      }
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
    }
  }
});




// WEBPACK FOOTER //
// ./src/permission.js